import { useAuthUserQuery, useSubscriptionStatusQuery } from "@/hooks";
import TrialFormatPriceSVOD from "./TrialFormatPriceSVOD";
import NonTrialFormatPriceSVOD from "./NonTrialFormatPriceSVOD";

export default function FormatPriceSVOD({ price, ext, course }) {
  const {
    data,
    loading: loadingSubscriptionStatus,
  } = useSubscriptionStatusQuery({
    variables: { courseId: Number(course?.id) },
  });
  const { data: user, loading: loadingUser } = useAuthUserQuery();
  if (loadingUser && loadingSubscriptionStatus) return null;
  const loggedIn = !loadingUser && user?.user;
  const isTrialEnabled = loggedIn
    ? data?.subscriptionStatus?.is_trial_enabled
    : true;

  if (course?.trial_flag && isTrialEnabled) {
    return (
      <TrialFormatPriceSVOD
        price={price}
        ext={ext}
        course={course}
      ></TrialFormatPriceSVOD>
    );
  } else {
    return (
      <NonTrialFormatPriceSVOD
        price={price}
        ext={ext}
      ></NonTrialFormatPriceSVOD>
    );
  }
}
